import { Container } from "./DetailTags.styled";

export interface DetailTagsProps {
  title: string;
  content: string[];
}

const DetailTags = ({ title, content }: DetailTagsProps) => {
  return (
    <Container>
      {title && <h4>{title}</h4>}
      <ul>
        {content?.map((tag, idx) => {
          return <li key={idx}>{tag}</li>;
        })}
      </ul>
    </Container>
  );
};

export default DetailTags;
